/**
 * Frontファイル更新チェック
 */
const getDefaultState = () => {
  return {
    current_identifier: null,
  }
}

const update_checker = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * サーバー上のhtmlファイルからhash値を
     * @param commit
     * @param state
     * @return {Promise<unknown>}
     */
    index ({ commit, state }) {

      const url = process.env.VUE_APP_DRIVER_URL
      /**
       * ハッシュを計算する
       * 与えられた文字列のハッシュ値を計算します。
       * このメソッドに、index.htmlの内容をすべて渡し、
       * ハッシュ値を計算してもらう、という寸法です。
       * @see https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript/7616484#7616484
       * @param str
       * @return {number}
       */
      const createHash = (str) => {
        const len = str.length;
        let hash = 0;
        if (len === 0) return hash;
        let i;
        for (i = 0; i < len; i++) {
          hash = ((hash << 5) - hash) + str.charCodeAt(i);
          hash |= 0; // Convert to 32bit integer
        }
        return hash
      }

      /**
       * ハッシュ値を比較
       * state用意した `current_identifier` と、
       * 計算したハッシュ値を比較します。
       * stateに値が保持されていない場合は強制リロードを実施する「reload」を返す.
       * stateに保持されている値がhash値と一致しない場合はダイアログ表示を表す「changed」を返す.
       * stateに保持されている値とhash値が一致する場合は変更なしを表す「unchanged」を返す.
       * @param hash
       * @return {string}
       */
      const judgeHash = (hash) => {
        if (!state.current_identifier) {
          return 'reload'
        }
        if (state.current_identifier !== hash) {
          return 'changed'
        }
        return 'unchanged'
      }

      return new Promise((resolve) => {

        if (process.env.VUE_APP_ENV === 'development') {
          resolve('development')
          return
        }
        fetch(url,{cache: "no-store"})
          .then(res => {
            if (res.status !== 200) {
              throw Error('Cannot access server.');
            }
            return res.text()
          })
          .then(html => {
            let hash = createHash(html)
            const result = judgeHash(hash)
            // 変更あり・なしに関わらずHash値を保持する.
            commit("SET_FILE_HASH", {hash: hash})
            resolve(result)
          })
          .catch(err => console.error(err))
      })
    },
  },
  mutations: {
    ["SET_FILE_HASH"] (state, { hash }) {
      state.current_identifier = hash
    },
  },
}

export default update_checker
